__turbopack_context__.v({
  "msgWrapper": "TooltipConstraints-module__LtrZxq__msgWrapper",
  "success": "TooltipConstraints-module__LtrZxq__success",
  "tooltipIcon": "TooltipConstraints-module__LtrZxq__tooltipIcon",
});
